module.exports = __webpack_public_path__ + "img/logo-malam-white.113a0c17.svg";